import { Box, Typography } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useRef, useState } from "react";
import styles from "../../devotee/devotee.module.scss";
import constants from "../../../config/constants.json";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import { CommonButton } from "../../common/StyledComponents/StyledFields";
import toast from "react-hot-toast";
import apiPath from "../../../config/apiPaths.json";
import { DonationReportResponseProps } from "../../../infrastructure/GlobalContextProvider";
import Sign_Chairman from "../../../assets/RYSignature3.png";
import President from "../../../assets/President.png";
import ErrorPopup from "../../common/ErrorPopup";
import { useReactToPrint } from "react-to-print";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";

interface DonationReportProps {
  ReportData: any;
  formData: any;
}

const YearEndDonationData = (props: DonationReportProps): JSX.Element => {
  console.log("props", props);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const currentDate = new Date();
  const [itemsData, setItemsData] = useState<DonationReportResponseProps[]>([]);
  const [year, setYear] = useState("");
  const [userDetails, setUserdetails] = useState({
    address: "",
    city: "",
    zipcode: "",
    state: "",
    country: "",
    firstname: "",
    middleName: "",
    lastname: "",
  });
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  const [tanAmount, setTanAmount] = useState<string>("");
  const [buttondisable, setButtonDisable] = useState<boolean>(false);
  const [signInName, setSignInName] = useState("");
  const signInNameUpper = signInName.toUpperCase();
  const [chairmanPresidentNames, setChairmanPresidentNames] = useState([]);

  useEffect(() => {
    if (signInName) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.getDevoteeDetails}/${signInNameUpper}`,
        includeToken: true,
      })
        .then((res) => {
          setUserdetails({
            address: res.data.address,
            city: res.data.city,
            zipcode: res.data.zipcode,
            state: res.data.state,
            country: res.data.country,
            firstname: res.data.firstname,
            middleName: res.data.middleName,
            lastname: res.data.lastname,
          });
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  }, [signInName]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/temple-management/public/findChairmanAndPresidentNames",
      includeToken: false,
    })
      .then((res) => {
        console.log(res.data);
        setChairmanPresidentNames(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setItemsData(props.ReportData?.donations);
    setTanAmount(props.ReportData?.totalTangibleAmount);
    setYear(props.ReportData?.year);
    setSignInName(props.formData.signInName);
  }, []);

  const PrintRef = useRef<any>(null);

  const input = PrintRef.current;

  const [loader, setloader] = useState(false);

  const downloadPDF = () => {
    setloader(true);
    setButtonDisable(true);

    if (!input) {
      console.error("pdfRef is not assigned to an HTML element");
      return;
    }
    setloader(true);
    void html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4", true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 0;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save(`report_${"YearEndDonationReport"}.pdf`);
      setButtonDisable(false);
      setloader(false);
    });
  };

  const handlePrint = useReactToPrint({
    content: () => PrintRef.current,
  });

  const HeaderDonation = (): React.ReactElement => {
    return (
      <Box className={styles.Header}>
        <Box className={styles.ImageAndImageName}>
          <img src="/images/TempleOldLogo.png" className={styles.HeaderImage} />
          <Typography className={styles.TempleNameData}>
            Shiva -Vishnu Temple
          </Typography>
        </Box>

        <Box className={styles.TempleAddress}>
          <Typography className={styles.TempleAddressData}>
            Hindu Community and Cultural Center
            <br />A Registered Non-Profit Organization
            <br />
            Tax ID: 94-2427126, Inc: D0821589,
            <br /> 1232, Arrowhead Ave, Livermore, CA <br />
            94551 Tel: (925) 449-6255, Fax: (925) 455-0404.
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <div className={styles.DonationReportLayout} ref={PrintRef}>
        <Box className={styles.reportContent}>
          <Box>{HeaderDonation()}</Box>
          <br />
          <Typography className={styles.SignInName}>
            {formattedDate} <br />
            <br /> Devotee Sign-in Name: <b>{signInName}</b>
          </Typography>
          <Typography style={{ marginTop: "0px" }}>
            <b>
              {userDetails.firstname} {userDetails.middleName}{" "}
              {userDetails.lastname},
            </b>
          </Typography>
          <Typography className={styles.SignInAddress}>
            <b>
              {" "}
              {userDetails.address},
              <br />
              {userDetails.city}, {userDetails.state}, {userDetails.country} -{" "}
              {userDetails.zipcode}{" "}
            </b>
          </Typography>

          <Typography className={styles.loggedInMember}>
            Dear {userDetails.firstname} {userDetails.middleName}{" "}
            {userDetails.lastname},{" "}
          </Typography>
          <Typography className={styles.loogedMemberGratitude}>
            Thank you for your generous donation to Hindu Community and Cultural
            Center, Shiva-Vishnu Temple, Livermore, California for the year{" "}
            {year} :
          </Typography>
          {itemsData
            .slice(0, -1)
            .map((item: DonationReportResponseProps, index: number) => (
              <Box className={styles.paymentDetails} key={index}>
                <Typography className={styles.paymentDetailsData}>
                  {item.type}:
                </Typography>
                <Typography className={styles.paymentDetailsData}>
                  {item.amount}
                </Typography>
              </Box>
            ))}
          {itemsData.length > 0 ? (
            <Box className={styles.paymentDetails} sx={{ paddingTop: "5px" }}>
              <Typography>
                <b>{itemsData[itemsData.length - 1].type} :</b>
              </Typography>
              <Typography>
                <b>{itemsData[itemsData.length - 1].amount} </b>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          <Typography className={styles.AboutData}>
            This information is a record of contributions you made to HCCC
            during {year} and tangible value of goods and services received by
            you in return for these contributions during the {year} was{" "}
            {tanAmount}.
          </Typography>

          <Typography className={styles.AboutData}>
            Please take a moment to review and verify the above amounts for
            accuracy. If you find any discrepancies, please contact us as soon
            as possible. Please indicate your Sign-in Name in your
            correspondence.
          </Typography>
          <Typography className={styles.AboutData}>
            We appreciate your patronage and look forward to your continued
            involvement with the Shiva-Vishnu Temple.
          </Typography>
          <Box className={styles.ClosingSignature}>
          {chairmanPresidentNames.map((item:any) => (
              <div  key={item.username}>
                <img
                  src={item.username === 'CHAIRMAN' ? Sign_Chairman : President}
                  style={{ height: "50px", width: "200px" }}
                  alt="Signature"
                />
                <Typography className={styles.SignatureData} >
                {`${item.fullName} , ${item.username.toLowerCase()}`}
                </Typography>
              </div>
              ))}
            </Box>
        </Box>
      </div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "16px",
          float: "right",
          marginTop: "16px",
        }}
      >
        <CommonButton onClick={handlePrint}>Print</CommonButton>
        <CommonButton onClick={downloadPDF} disabled={buttondisable}>
          <ButtonLoader isBtnLoading={loader} btnText={"Download"} />
        </CommonButton>
      </Box>
    </>
  );
};

export default YearEndDonationData;
